<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:40:47
-->
<template>
	<div class="mt-12">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="商品信息">
				<el-input v-model="formData['product_search']" placeholder="请输入商品名称/ID"></el-input>
			</el-form-item>
			<el-form-item label="合作方信息">
				<el-input v-model="formData['cooperation_search']" placeholder="请输入商家/团长名称或ID"></el-input>
			</el-form-item>
			<el-form-item label="合作类型">
				<el-select v-model="formData['cooperation_type']" clearable placeholder="请选择">
					<el-option :label="item.label" :value="item.value" v-for="(item, index) in cooperationArr" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
export default {
	name: 'search',
	data() {
		return {
			formData: {},
			labelWidth: '140px',
			tabName: '0',
			cooperationArr: [
				{
					label: '全部',
					value: 0,
				},
				{
					label: '团长',
					value: 1,
				},
				{
					label: '商家',
					value: 2,
				},
			],
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
